import React from 'react';
import { SvgProps } from '../../../types/svg';

const DEFAULT_SIZE = 120;

const Code404 = ({ width, height }: SvgProps) => (
  <svg
    width={width ?? DEFAULT_SIZE}
    height={height ?? DEFAULT_SIZE}
    viewBox="0 0 121 121"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_378_67393)">
      <path
        d="M54.3398 88.5093H53.7837C47.0593 88.5093 41.5862 83.0362 41.5862 76.3118V61.224C41.5862 59.702 40.3496 58.4581 38.8203 58.4581V54.5142C40.3642 54.5142 41.791 55.041 42.9325 55.9264C42.1569 54.8874 41.7032 53.5996 41.6959 52.202V51.4923V30.4044C41.6959 23.5996 47.2349 18.0605 54.0398 18.0605C60.8154 18.0605 66.3545 23.5703 66.3837 30.3459L66.4642 54.5435H87.8447V58.4874H66.4788L66.5374 76.2752C66.552 79.5386 65.2862 82.6118 62.9813 84.9313C60.6764 87.2362 57.6032 88.5093 54.3398 88.5093ZM44.1764 57.1923C45.0252 58.3118 45.5301 59.7093 45.5301 61.224V76.3118C45.5301 80.863 49.2325 84.5727 53.791 84.5727H54.3471C56.5569 84.5727 58.6349 83.7093 60.2008 82.1435C61.7593 80.5776 62.6154 78.4996 62.6081 76.2825L62.5496 58.4874H47.9886C46.5545 58.4874 45.2301 58.0045 44.1764 57.1923ZM54.0398 22.0044C49.4081 22.0044 45.6325 25.7727 45.6325 30.4118V52.2093C45.6325 53.5044 46.6862 54.5508 47.9813 54.5508H62.5203L62.4398 30.3679C62.4252 25.7508 58.6569 22.0044 54.0398 22.0044Z"
        fill="#999999"
      />
      <path
        d="M28.6284 92.175H24.6845V58.4653H7.03571C4.43815 58.4653 2.15522 56.9945 1.08693 54.6165C0.0186376 52.2458 0.428394 49.5604 2.15522 47.614L17.2284 30.6311C19.043 28.5897 21.8674 27.8945 24.4211 28.8677C26.9747 29.8409 28.6284 32.2262 28.6284 34.9628V54.5287H38.8211V58.4726H28.6284V92.175ZM22.0577 32.3799C21.4942 32.3799 20.7991 32.5628 20.1845 33.2579L5.104 50.2409C4.40888 51.0238 4.25522 52.0555 4.67961 53.0067C5.11132 53.9579 5.98937 54.5287 7.02839 54.5287H24.6845V34.9628C24.6845 33.3092 23.4113 32.7018 23.0235 32.5555C22.8552 32.4897 22.4967 32.3799 22.0577 32.3799Z"
        fill="#999999"
      />
      <path d="M30.704 54.5439H28.6406V58.4952H30.704V54.5439Z" fill="#666666" />
      <path d="M68.5868 54.5439H66.5234V58.4952H68.5868V54.5439Z" fill="#666666" />
      <path
        d="M73.8764 54.5439H84.1935V58.4952H75.874C73.913 57.9464 72.8594 55.3488 72.8594 54.5439H73.8764Z"
        fill="#666666"
      />
      <path d="M62.5712 54.5439H60.5078V58.4952H62.5712V54.5439Z" fill="#666666" />
      <path d="M24.6806 54.5439H22.6172V58.4952H24.6806V54.5439Z" fill="#666666" />
      <path
        d="M102.253 83.2921H98.309V58.4653H80.6529C78.0553 58.4653 75.7724 56.9945 74.7041 54.6165C73.6358 52.2458 74.0456 49.5604 75.7724 47.614L90.8456 30.6311C92.6602 28.5897 95.4846 27.8945 98.0383 28.8677C100.592 29.8409 102.246 32.2262 102.246 34.9628V54.5287H106.489V58.4726H102.246V83.2921H102.253ZM95.6822 32.3799C95.1188 32.3799 94.4236 32.5628 93.809 33.2579L78.7358 50.2409C78.0407 51.0238 77.887 52.0555 78.3114 53.0067C78.7358 53.9579 79.6212 54.5287 80.6602 54.5287H98.3163V34.9628C98.3163 33.3092 97.0431 32.7018 96.6553 32.5555C96.4724 32.4897 96.1212 32.3799 95.6822 32.3799Z"
        fill="#999999"
      />
      <path d="M103.772 54.543H102.25V58.4942H103.772V54.543Z" fill="#999999" />
      <path d="M98.329 54.543H96.2656V58.4942H98.329V54.543Z" fill="#666666" />
      <path
        d="M84.7147 107.856L77.1635 93.0461V90.3388H77.7635C78.3415 90.3388 78.8098 89.8705 78.8098 89.2924C78.8098 88.7144 78.3415 88.2461 77.7635 88.2461H68.9976C68.4196 88.2461 67.9513 88.7144 67.9513 89.2924C67.9513 89.8705 68.4196 90.3388 68.9976 90.3388H69.5976V93.0461L62.0464 107.856C61.1611 109.59 62.4196 111.646 64.3659 111.646H82.3879C84.3342 111.646 85.6001 109.59 84.7147 107.856Z"
        fill="url(#paint0_linear_378_67393)"
      />
      <path d="M76.6172 85.2461H70.1562V88.2461H76.6172V85.2461Z" fill="#666666" />
      <path d="M77.1742 90.251H69.5938V91.9705H77.1742V90.251Z" fill="#999999" />
      <path
        d="M80.438 109.312H65.7966C65.3502 109.312 64.9844 108.946 64.9844 108.5V108.456C64.9844 108.009 65.3502 107.644 65.7966 107.644H80.438C80.8844 107.644 81.2502 108.009 81.2502 108.456V108.5C81.2429 108.946 80.8844 109.312 80.438 109.312Z"
        fill="#999999"
      />
      <path
        d="M30.6516 88.8675V82.4432H31.2809C31.8882 82.4432 32.3857 81.9529 32.3857 81.3383C32.3857 80.731 31.8955 80.2334 31.2809 80.2334H30.6516H22.676H22.0467C21.4394 80.2334 20.9418 80.7236 20.9418 81.3383C20.9418 81.9456 21.4321 82.4432 22.0467 82.4432H22.676V88.8675C18.1394 90.4992 14.8906 94.8456 14.8906 99.9456C14.8906 106.443 20.1589 111.719 26.6638 111.719C33.1687 111.719 38.437 106.45 38.437 99.9456C38.437 94.8456 35.1882 90.5066 30.6516 88.8675Z"
        fill="url(#paint1_linear_378_67393)"
      />
      <path d="M30.1944 77.124H23.2578V80.3435H30.1944V77.124Z" fill="#666666" />
      <path d="M30.7377 82.4434H22.5938V84.2873H30.7377V82.4434Z" fill="#999999" />
      <path
        d="M33.5788 105.748C31.9105 107.702 29.43 108.938 26.6568 108.938C23.891 108.938 21.4105 107.702 19.7422 105.748H33.5788Z"
        fill="#999999"
      />
      <path d="M106.495 53.6289H103.773V59.2631H106.495V53.6289Z" fill="#666666" />
      <path d="M108.454 54.5508H106.5V58.4947H108.454V54.5508Z" fill="#999999" />
      <path
        d="M113.989 62.8115C117.585 62.8115 120.501 59.8959 120.501 56.2993C120.501 52.7027 117.585 49.7871 113.989 49.7871C110.392 49.7871 107.477 52.7027 107.477 56.2993C107.477 59.8959 110.392 62.8115 113.989 62.8115Z"
        fill="#666666"
      />
      <path
        d="M113.988 60.521C116.319 60.521 118.21 58.6308 118.21 56.2991C118.21 53.9674 116.319 52.0771 113.988 52.0771C111.656 52.0771 109.766 53.9674 109.766 56.2991C109.766 58.6308 111.656 60.521 113.988 60.521Z"
        fill="white"
      />
      <path
        d="M113.997 56.2994H113.975C113.77 56.2994 113.602 56.1311 113.602 55.9263V53.2921C113.602 53.0872 113.77 52.9189 113.975 52.9189H113.997C114.202 52.9189 114.37 53.0872 114.37 53.2921V55.9263C114.37 56.1385 114.202 56.2994 113.997 56.2994Z"
        fill="#999999"
      />
      <path
        d="M113.992 57.8066C114.824 57.8066 115.499 57.1318 115.499 56.2993C115.499 55.4668 114.824 54.792 113.992 54.792C113.159 54.792 112.484 55.4668 112.484 56.2993C112.484 57.1318 113.159 57.8066 113.992 57.8066Z"
        fill="#999999"
      />
      <path
        d="M112.498 107.578L104.391 91.6707V75.6755H105.035C105.657 75.6755 106.154 75.1707 106.154 74.556C106.154 73.9341 105.649 73.4365 105.035 73.4365H95.6248C95.0029 73.4365 94.5053 73.9414 94.5053 74.556C94.5053 75.178 95.0102 75.6755 95.6248 75.6755H96.2688V91.6707L88.1614 107.578C87.2102 109.444 88.5639 111.646 90.6566 111.646H110.01C112.096 111.646 113.449 109.437 112.498 107.578Z"
        fill="url(#paint2_linear_378_67393)"
      />
      <path d="M103.796 70.2021H96.8594V73.4217H103.796V70.2021Z" fill="#666666" />
      <path d="M104.402 75.6533H96.2578V77.4972H104.402V75.6533Z" fill="#999999" />
      <path
        d="M107.796 108.719H92.8543C92.1738 108.719 91.625 108.17 91.625 107.489V107.424C91.625 106.743 92.1738 106.194 92.8543 106.194H107.796C108.476 106.194 109.025 106.743 109.025 107.424V107.489C109.025 108.17 108.476 108.719 107.796 108.719Z"
        fill="#999999"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_378_67393"
        x1="61.7625"
        y1="99.9493"
        x2="85.0013"
        y2="99.9493"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CBCDD1" />
        <stop offset="1" stopColor="#E4E5EA" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_378_67393"
        x1="14.8908"
        y1="95.9789"
        x2="38.4346"
        y2="95.9789"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CBCDD1" />
        <stop offset="1" stopColor="#E4E5EA" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_378_67393"
        x1="87.8508"
        y1="92.5374"
        x2="112.81"
        y2="92.5374"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CBCDD1" />
        <stop offset="1" stopColor="#E4E5EA" />
      </linearGradient>
      <clipPath id="clip0_378_67393">
        <rect width="120" height="120" fill="white" transform="translate(0.5 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default Code404;
